import { articlePreviews } from "@/mocks/categories";
import { useNavigate } from "react-router-dom";

export default function ArticlesSection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-6">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-article-line"></i>
              Shopping Guides
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Pandabuyspreadsheet
              <br />
              Guides &amp; Tips
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-xs leading-relaxed">
            Expert articles covering every pandabuyspreadsheet category — from sneaker rankings to
            budget shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlePreviews.map((article) => (
            <article
              key={article.slug}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer"
              onClick={() => {
                navigate(`/${article.slug}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="inline-flex items-center gap-1.5 text-accent-600 text-xs font-medium">
                  <span>Read More</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            onClick={() => {
              navigate("/pandabuyspreadsheet-guide");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-600 text-sm font-medium hover:bg-background-50 hover:border-accent-300 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            View All Guides
            <i className="ri-arrow-right-line text-base"></i>
          </button>
        </div>
      </div>
    </section>
  );
}